module.exports = __webpack_public_path__ + "static/media/step1.efe01077.png";